module.exports = __webpack_public_path__ + "img/CPa.28882fc0.png";